import {IconProps} from './types';

export const SmsMessage: React.FC<IconProps> = ({ 
    className, 
    width = 15, 
    height = 15, 
    fill = 'black' 
}) => (
    <svg 
        width={width} 
        height={height} 
        viewBox="0 0 15 15" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
        className={className}
    >
        <path 
            d="M4.03437 11.875L1.25 14.0625V2.5C1.25 2.33424 1.31585 2.17527 1.43306 2.05806C1.55027 1.94085 1.70924 1.875 1.875 1.875H13.125C13.2908 1.875 13.4497 1.94085 13.5669 2.05806C13.6842 2.17527 13.75 2.33424 13.75 2.5V11.25C13.75 11.4158 13.6842 11.5747 13.5669 11.6919C13.4497 11.8092 13.2908 11.875 13.125 11.875H4.03437ZM3.60188 10.625H12.5V3.125H2.5V11.4906L3.60188 10.625ZM6.875 6.25H8.125V7.5H6.875V6.25ZM4.375 6.25H5.625V7.5H4.375V6.25ZM9.375 6.25H10.625V7.5H9.375V6.25Z" 
            fill={fill}
        />
    </svg>
);
